module.exports = __webpack_public_path__ + "static/media/1POLICY43.2680b12a.jpg";